import { useQuery } from '@tanstack/react-query'

export default function useUnlocodes(countryCodeFilter: string | null) {
  return useQuery<[string, string][]>({
    queryKey: ['unlocodes', countryCodeFilter?.toUpperCase()],
    queryFn: async () => {
      const response = await fetch(`/unlocodes/${countryCodeFilter?.toUpperCase()}.json`)
      return response.json() as Promise<[string, string][]>
    },
    enabled: !!countryCodeFilter
  })
}
